<template>
	<section>
		<div class="d-flex flex-row bd-highlight mb-3">
			<router-link :to="{name: 'rel_select' }" class="btn btn-sm btn-primary">Voltar</router-link>
			<button class="btn btn-sm btn-primary ml-1" v-if="resultado">Gerar PDF</button>
		</div>

		<ul class="nav nav-tabs" role="tablist" style="margin-bottom: 5px;">
	        <li class="nav-item">
	        	<router-link :to="{name: 'rel_resumo', params: {tab: 'Resumo'} }" class="nav-link active" data-toggle="tab">Resumo</router-link>
	        </li>

	        <li class="nav-item">
	        	<router-link :to="{name: 'rel_detalhe', params: {tab: 'Detalhes'} }" class="nav-link" data-toggle="tab">Detalhes</router-link>
	        </li>
	    </ul>

	    <div class="row">
		    	<transition mode="out-in" name="leftIn">
		        <div v-if="resultado" class="col-12">
		            <div class="tab-content">
		            	<transition mode="out-in" name="leftIn">
							<router-view :key="tab" :resultado="resultado"></router-view>
						</transition>
		            </div>
		        </div>
		        <Loading v-else />
		    </transition>
	    </div>

	</section>
</template>

<script>
	import api from "@/mixins/api.js"

	export default {
		name: 'Resultado',
		mixins: [ api ],
		props: ["tab", "filtro", "relatorio"],

		data() { 
			return { resultado: null }
		},

		beforeRouteUpdate(to, from, next) {
			next();
		},

		async created() {
			const unidade = ( this.filtro.unidade > 0 ) ? await this.GET("Unidade", this.filtro.unidade) : null;
			this.get_data();

			setTimeout( () => this.resultado = {
				unidade: ( unidade ) ? unidade.result.nome : "Todos",
				inicio: this.filtro.inicio,
				fim: this.filtro.fim,
				ligacoes: 30,
				tempo: "01:57:45",
				custo: 1.25
			}, 2000)
		},

		methods: {
			async get_data() {
				// const response = await this.GET("Dialstatus", params)
			}
		}
	};
</script>

<style>
</style>